import { FC, memo } from 'react';

import { EmptyInvitations, InvitationsList } from '..';
import { PendingInvitationsProps } from './PendingInvitations.types';

export const PendingInvitations: FC<PendingInvitationsProps> = memo((props) => {
    const { pendingInvitations } = props;

    if (!pendingInvitations?.length) {
        return <EmptyInvitations />;
    }

    return <InvitationsList pendingInvitations={pendingInvitations} />;
});

PendingInvitations.displayName = 'PendingInvitations';
